import { getRegistration as getSWReg } from "@/service-worker/register-sw";

export const createSWRegistrationUpdateMiddleware = (router) => {
  const init = () => {
    router.beforeEach((_, __, next) => {
      const reg = getSWReg();
      if (reg) {
        reg.update();
      }
      next();
    });

    return router;
  };

  return init();
};
